export default "<div class=\"autologin-wrapper loading\"></div>";